// Shared constants for the GPS "Formulaires" feature (frontend).
// Note: NUMERIC_GATE has a separate backend copy in backend/utils/gpsForms.js.

// Debounce window (ms) before the primary fetch fires after a filter/period change.
export const FETCH_DEBOUNCE_MS = 300;

// Single-choice questions with at most this many modalities render as a donut.
export const DONUT_MAX_MODALITIES = 6;

// Numeric questions with at most this many distinct values render as categorical bars.
export const NUMERIC_DISTINCT_MAX = 7;

// Minimum parse ratio for numeric questions to surface averages (below → distribution).
export const NUMERIC_GATE = 0.9;
